// Import React Package
import { useTranslation } from 'react-i18next'
import { NavLink, Link } from 'react-router-dom';
import { IoIosClose, IoMdGlobe, IoIosMenu } from "react-icons/io";
import { useDispatch, useSelector } from 'react-redux'
import { setWebLanguage } from '../rtk/slicers/languageSlicer'
import { AiFillMessage } from "react-icons/ai";
import { FaLocationArrow } from "react-icons/fa";
import { BiSolidPhoneCall } from "react-icons/bi";
import { HiMenuAlt1 } from "react-icons/hi";
import { useEffect } from 'react';
// End

// Import Assets / Images
import djMotorsLogo from '../images/djLogo.svg';
// End

// Import Componets 

// End

// Import Css Files
import '../css/navbar.css';
import { useState } from 'react';
// End


function Navbar() {
    const { t } = useTranslation();
    let [openOverLay, setOverLay] = useState(false);
    const openOverLayFunc = () => {
        setOverLay(true);
    }
    const closeOverLayFunc = () => {
        setOverLay(false)
    }
    const changeLanguage = (lang) => {
        dispatch(setWebLanguage(lang))
    }

    const language = useSelector(state => state.webLanguage);

    const dispatch = useDispatch();


//   useEffect(() => {
//     // تعطيل التمرير عندما يكون openOverLay true
//     if (openOverLay) {
//       document.body.style.overflow = 'hidden';
//     } else {
//       document.body.style.overflow = 'auto'; // استعادة التمرير عند غلق الـ overlay
//     }

//     // تنظيف التأثير عند تغيير حالة الـ overlay
//     return () => {
//       document.body.style.overflow = 'auto'; // إعادة التمرير عند إلغاء التفعيل
//     };
//   }, [openOverLay]);

    return (
        <div className='navbar-container bg-white shadow-lg'>
            <div className='navbar sm:max-w-4xl md:max-w-6xl lg:max-w-7xl mx-auto flex flex-row justify-between items-center p-4'>

            <div className='nav-col-logo'>
                    <Link to={'/'}>
                        <img src={djMotorsLogo} alt="dj-motors-image" className='w-3/4' />
                    </Link>
                </div>
                <div className='nav-col-links hidden md:hidden lg:flex col-span-3'>
                    <ul className='w-full flex flex-row md:flex-wrap md:justify-start justify-center items-center gap-4 p-2 '>
                        <li><NavLink to="">{t('home')}</NavLink></li>
                        <li><NavLink to="/about">{t('about')}</NavLink></li>
                        <li><NavLink to="/brands">{t('brands')}</NavLink></li>
                        <li className='relative' id='sparePartsLink'><NavLink to="/spare-parts">{t('spareparts')}</NavLink></li>
                        <li><NavLink to="/services">{t('services')}</NavLink></li>
                        <li><NavLink to="/offers">{t('offers')}</NavLink></li>
                        <li><NavLink to="/clients-reviews">{t('reviews')}</NavLink></li>
                        <li><NavLink to="/help-client">{t('call us')}</NavLink></li>
                        <li><NavLink to="/compare-cars">{t('compareCars')}</NavLink></li>
                        <li ><NavLink to="/book-maintenance-appointment">{t('bookaFix')}</NavLink></li>
                        <li className={`w-fit p-2 rounded-md bg-mainRedColor text-white text-sm font-bold`}><NavLink to="/buy-now">{t('buycar')}</NavLink></li>
                    </ul>
                </div>
               
                <div className='nav-col-menuIcon sm:block md:block lg:hidden' onClick={openOverLayFunc}>
                    <HiMenuAlt1 className='text-2xl text-mainRedColor' />
                    {/* <IoIosMenu className='text-3xl text-mainRedColor' /> */}
                </div>

                {
                    openOverLay && <div className={`absolute z-[100000000000000000000] top-0 left-0 w-full h-full min-h-screen bg-[rgba(0,0,0,0.8)]`}>

                        <div className='nav-col-links fixed w-72  bg-white h-full p-2'>
                            

                            <div className='flex flex-row gap-1 justify-between items-center p-2'>
                                <button className={`w-16 h-16 rounded-full cursor-pointer hover:scale-105 transition-all duration-100`} onClick={closeOverLayFunc} >
                                    <IoIosClose className={`text-white text-lg bg-mainRedColor rounded-full`} />
                                </button>
                                {
                                    language === 'ar' ? <button className='text-mainRedColor font-bold text-xs cursor-pointer' onClick={() => changeLanguage('en')}><IoMdGlobe className='text-sm text-mainRedColor flex flex-row gap-2' /> EN</button> : <button className='text-mainRedColor font-bold text-xs' onClick={() => changeLanguage('ar')}><IoMdGlobe className='text-xl text-mainRedColor flex flex-row gap-2' /> AR</button>
                                }

                            </div>

                          


                            <ul className='w-full flex flex-col justify-center gap-2 p-1 '>
                                <li className={`text-xs`} onClick={closeOverLayFunc}><NavLink to="">{t('home')}</NavLink></li>
                                <hr className={`w-full opacity-50`}/>
                                <li className={`text-xs`} onClick={closeOverLayFunc}><NavLink to="/about">{t('about')}</NavLink></li>
                                <hr className={`w-full opacity-50`}/>
                                <li className={`text-xs`} onClick={closeOverLayFunc}><NavLink to="/brands">{t('brands')}</NavLink></li>
                                <hr className={`w-full opacity-50`}/>
                                <li className={`text-xs`} onClick={closeOverLayFunc}><NavLink to="/spare-parts">{t('spareparts')}</NavLink></li>
                                <hr className={`w-full opacity-50`}/>
                                <li className={`text-xs`} onClick={closeOverLayFunc}><NavLink to="/services">{t('services')}</NavLink></li>
                                <hr className={`w-full opacity-50`}/>
                                <li className={`text-xs`} onClick={closeOverLayFunc}><NavLink to="/offers">{t('offers')}</NavLink></li>
                                <hr className={`w-full opacity-50`}/>
                                <li className={`text-xs`} onClick={closeOverLayFunc}><NavLink to="/clients-reviews">{t('reviews')}</NavLink></li>
                                <hr className={`w-full opacity-50`}/>
                                <li className={`text-xs`} onClick={closeOverLayFunc}><NavLink to="/help-client">{t('call us')}</NavLink></li>
                                <hr className={`w-full opacity-50`}/>
                                <li className={`text-xs`} onClick={closeOverLayFunc}><NavLink to="/compare-cars">{t('compareCars')}</NavLink></li>
                                <hr className={`w-full opacity-50`}/>
                                <li className={`text-xs`} onClick={closeOverLayFunc} ><NavLink to="/book-maintenance-appointment">{t('bookaFix')}</NavLink></li>
                                <hr className={`w-full opacity-50`}/>
                                <li className={`w-fit p-1 rounded bg-mainRedColor text-white text-xs font-bold`} onClick={closeOverLayFunc} ><NavLink to="/buy-now">{t('buycar')}</NavLink></li>
                                <hr className={`w-full opacity-50`}/>
                            </ul>


                            
                            <div className="header w-full p-2 flex flex-row flex-wrap justify-between items-center gap-2 rounded-md">
                                <div className="header-col flex flex-row gap-2 justify-center">
                                    <AiFillMessage className={`text-mainRedColor text-sm`}/>
                                    {/* <img src={emailIcon} alt="" className='w-4' /> */}
                                    <Link to={"mailto:info@djmotors.sa"} className="header-col-description text-xs text-gray-900 tracking-wider hover:text-gray-700 font-black">info@djmotors.sa</Link>
                                </div>
                                <div className="header-col flex flex-row gap-2 justify-center items-center">
                                    <BiSolidPhoneCall className={`text-mainRedColor text-sm`}/>
                                    {/* <img src={callIcon} alt="" className='w-4' /> */}
                                    {/* <Link to={'tel:0541681105'}>
                                        <span className="header-col-description text-xs text-gray-900 tracking-wider hover:text-gray-700 cursor-pointer font-black">0541681105</span>
                                    </Link> */}
                                    {/* <img src={whatsappIcon} alt="" className='w-4' /> */}
                                </div>
                                <div className="header-col flex flex-row gap-2 justify-center items-center">
                                    <FaLocationArrow className={`text-mainRedColor text-sm`}/>
                                    {/* <img src={locationIcon} alt="" className='w-4' /> */}
                                    <Link to={'https://maps.app.goo.gl/fqjzbQnhHPGkifRS8'} target='_blank'><span className={`header-col-description text-xs text-gray-900  hover:text-gray-700 cursor-pointer ${language === 'en' ? 'tracking-wider' : ''} font-black`}>{t('location')}</span></Link>
                                </div>


                            </div>

                            

                        </div>

                    </div>
                }


            </div>
        </div>
    );
}

export default Navbar;